function getObjectSize(obj) {
  const size = new TextEncoder().encode(JSON.stringify(obj)).length;
  const kiloBytes = size / 1024;

  //make it just 2 number after ,
  return kiloBytes.toFixed(2);
}

export default getObjectSize;
